export const ru = {
    'accepted-status': 'Допущена к показам',
    'active-status': 'Активна',
    'archived-status': 'В архиве',
    'banner-type-content-promotion': 'Продвижение контента',
    'banner-type-cpm-indoor': 'Внутренняя реклама',
    'banner-type-cpm-indoor-1': 'Реклама в помещениях',
    'banner-type-cpm-outdoor': 'Наружная реклама',
    'banner-type-cpm_audio': 'Аудио',
    'banner-type-cpm_banner': 'Медийный баннер',
    'banner-type-cpm_geoproduct': 'Баннер в Яндекс.Метро',
    'banner-type-cpm_geoproduct-new': 'Баннер на гео-площадках',
    'banner-type-cpm_price': 'Прайсовое объявление',
    'banner-type-cpm_video': 'Видео',
    'banner-type-cpm_yndx_frontpage': 'Медийный баннер на Главной',
    'banner-type-dynamic': 'Динамическое объявление',
    'banner-type-internal': 'Внутренняя реклама',
    'banner-type-internal-autobudget': 'Автобюджетная кампания',
    'banner-type-internal-distrib': 'Дистрибуционные объявления',
    'banner-type-internal-free': 'Бесплатные объявления',
    'banner-type-mcbanner': 'Баннер на поиске',
    'banner-type-performance': 'Смарт-баннер',
    'banner-type-text-mobile': 'Текстово-графическое объявление мобильное',
    'button-group-type-chooser-banners': 'Баннеры',
    'custom-targeting': 'Опциональный таргетинг:',
    'date-campaigns': 'Даты действия кампании:',
    displays: 'Показы:',
    'draft-status': 'Черновик',
    'edit-group-hint-campaigns-part': {
        one: 'из {countCampaigns} кампании',
        some: 'из {countCampaigns} кампаний',
        many: 'из {countCampaigns} кампаний',
        none: 'из {countCampaigns} кампаний'
    },
    'edit-group-hint-groups-part': {
        one: 'Выбрана {count} группа',
        some: 'Выбрано {count} группы',
        many: 'Выбрано {count} групп',
        none: 'Выбрана {count} группа'
    },
    'edit-group-hint-only-campaigns-part': {
        one: 'Выбрана {count} кампания',
        some: 'Выбрано {count} кампании',
        many: 'Выбрано {count} кампаний',
        none: 'Выбрана {count} кампаний'
    },
    'fixed-targeting': 'Обязательный таргетинг:',
    'group-type-chooser-audio': 'аудио',
    'group-type-chooser-banners': 'баннеры',
    'group-type-chooser-geoproduct': 'баннер в Яндекс.Метро',
    'group-type-chooser-geoservice': 'баннер на гео-площадках',
    'group-type-chooser-indoor': 'внутренняя реклама',
    'group-type-chooser-indoor-1': 'реклама в помещениях',
    'group-type-chooser-outdoor': 'наружная реклама',
    'group-type-chooser-video': 'видео',
    'group-type-text': 'Текстово-графическое объявление',
    ltv: 'LTV',
    'moderation-status': 'На модерации',
    'no-status': 'Объявления не созданы',
    'preaccepted-status': 'Предварительно допущена к показам',
    'previous-version-showing-status-desc': 'Показывается предыдущая версия',
    'processing-status': 'Идет обработка',
    'rejected-status': 'Отклонена',
    'showing-status': 'Идут показы',
    'showing-status-desc': 'Идут показы',
    'stopped-status': 'Остановлена',
    'title-package': 'Пакеты:'
};
